import { useMutation } from "react-query";
import { clearCandidateSession } from "../candidateSession";

const logout = async (): Promise<void> => {
  clearCandidateSession();
};

export function useLogout() {
  const { isLoading, mutateAsync } = useMutation(logout);

  return { isLoggingOut: isLoading, logout: mutateAsync };
}
